export const TOURNAMENTS_SEARCH = "search";
export const TOURNAMENTS_SORT = "sort_by";
